import { IconButton } from '../ui/Icon'
import type { QueuedPhoto } from './useNotePhotoQueue'

interface Props {
  items: QueuedPhoto[]
  onRemove: (key: string) => void
  // Absent where nothing can have failed yet (the note isn't saved).
  onRetry?: (key: string) => void
}

// QueuedPhotoTiles are the photos not on the note yet, as tiles for a
// .note-photos grid: waiting for Save note, waiting their turn to go up,
// going up, or one that didn't upload, with Try again. Any but the one going
// up can be dropped: the API may already have that one.
export default function QueuedPhotoTiles({ items, onRemove, onRetry }: Props) {
  return (
    <>
      {items.map((item, i) => (
        <li key={item.key} className={`queued-photo queued-photo--${item.status}`}>
          <img src={item.url} alt={`New photo ${i + 1}`} />
          {item.status === 'queued' && <span className="queued-photo__state">Waiting…</span>}
          {item.status === 'uploading' && <span className="queued-photo__state">Uploading…</span>}
          {item.status === 'failed' && (
            <span className="queued-photo__state">
              <span>Didn't upload</span>
              {onRetry && (
                <button type="button" className="btn btn-secondary btn-compact" onClick={() => onRetry(item.key)}>
                  Try again
                </button>
              )}
            </span>
          )}
          {item.status !== 'uploading' && (
            <IconButton
              icon="close"
              label={`Remove new photo ${i + 1}`}
              size={16}
              className="queued-photo__remove"
              onClick={() => onRemove(item.key)}
            />
          )}
        </li>
      ))}
    </>
  )
}
